import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { getData, getMAList } from '../../features/mainSlice';
import {
  getGA4EventSetting,
  getIntegration,
  getNextResource,
  getOrganization,
  getOrganizationMembers,
  getService,
} from '../../features/organizationSlice';
import { getCouponList, getECStatus } from '../../features/superMarketSlice';

function Initial({ children }) {
  const { orgId, procedureId } = useParams();
  const dispatch = useDispatch();
  const { data } = useSelector(store => store.ma);
  const { platform } = data || {};

  useEffect(() => {
    const init = async () => {
      await Promise.all([
        dispatch(getData(procedureId)),
        dispatch(getOrganization(orgId)),
        dispatch(getService(orgId, 'ga4Event')),
        dispatch(getIntegration(orgId)),
        dispatch(getGA4EventSetting(orgId)),
        dispatch(getNextResource(orgId)),
        dispatch(getECStatus(orgId)),
        dispatch(getCouponList(orgId)),
      ]);
      await dispatch(getOrganizationMembers({ orgId, limit: 20 }));
    };

    init();
  }, []);

  useEffect(() => {
    dispatch(getMAList(orgId, platform));
  }, [platform]);

  return <>{children}</>;
}

export default Initial;
